import {
  BIKES_RESET,
  BIKE_SENDING,
  BIKE_DOWNLOADED,
  BIKES_DOWNLOADED,
  BIKES_FAILED,
  BIKES_PENDING,
} from './types';
import BikesApiService from '../../services/api/BikesApiService';
import { handleError } from '../infos/actions';

export const bikesResetAction = () => ({
  type: BIKES_RESET,
});

export const bikeSendingAction = () => ({
  type: BIKE_SENDING,
});

export const bikeDownloadedAction = (bike) => ({
  type: BIKE_DOWNLOADED,
  payload: bike,
});

export const bikesDownloadedAction = (bikes) => ({
  type: BIKES_DOWNLOADED,
  payload: bikes,
});

export const bikesFailedAction = (error) => ({
  type: BIKES_FAILED,
  payload: error,
});

export const bikesPendingAction = () => ({
  type: BIKES_PENDING,
});

export function resetBikes() {
  return (dispatch) => {
    dispatch(bikesResetAction());
  };
}

export function getBikes(authUserToken, role) {
  return (dispatch) => {
    dispatch(bikesPendingAction());
    return BikesApiService
      .getBikes(authUserToken, role)
      .then((data) => {
        dispatch(bikesDownloadedAction(data));
      })
      .catch((error) => {
        dispatch(bikesFailedAction(error));
        dispatch(handleError(error));
      });
  };
}

export function postBike(authUserToken, renterId, siteId, bike) {
  return (dispatch) => {
    dispatch(bikeSendingAction());
    return BikesApiService
      .postAdminBikes(authUserToken, renterId, siteId, bike)
      .then((data) => {
        dispatch(bikeDownloadedAction(data));
        return data;
      })
      .catch((error) => {
        dispatch(bikesFailedAction(error));
        dispatch(handleError(error));
        return null;
      });
  };
}

export function putBike(authUserToken, bikeId, bike) {
  return (dispatch) => {
    dispatch(bikeSendingAction());
    return BikesApiService
      .putRenterBike(authUserToken, bikeId, bike)
      .then((data) => {
        dispatch(bikeDownloadedAction(data));
        return data;
      })
      .catch((error) => {
        dispatch(bikesFailedAction(error));
        dispatch(handleError(error));
        return null;
      });
  };
}

export function putRenterBike(authUserToken, bikeId, bike) {
  return (dispatch) => {
    dispatch(bikeSendingAction());
    return BikesApiService
      .putRenterBike(authUserToken, bikeId, bike)
      .then((data) => {
        dispatch(bikeDownloadedAction(data));
      })
      .catch((error) => {
        dispatch(bikesFailedAction(error));
        dispatch(handleError(error));
      });
  };
}



// WEBPACK FOOTER //
// ./src/store/bikes/actions.js